import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getEmployerDocuments } from "../../api/document/getEmployerDocuments";
import { buildAutoCompleteOptions } from "../../helpers/buildOptions";
import {
  DocumentPageName,
  EmployerPageName,
  filterAccountsByEmployerPage,
  isAuthorisedToViewEmployerPage,
} from "../../helpers/user";
import { useApi } from "../../providers/ApiProvider";
import { useAuth } from "../../providers/AuthProvider";
import { User } from "../../types/User";
import DocumentList from "../components/DocumentList";

const EmployerDocumentList = ({
  me,
  page,
}: {
  me: User;
  page: DocumentPageName;
}) => {
  const navigate = useNavigate();
  const { getScopedPageUrl } = useAuth();
  const [navigationCheckComplete, setNavigationCheck] = useState(false);
  const { fetchFile } = useApi();

  const authorisedAccounts = me.accountPermissions
    ? filterAccountsByEmployerPage(
        me.accountPermissions,
        page as EmployerPageName
      )
    : [];

  useEffect(() => {
    if (
      me.accountPermissions &&
      isAuthorisedToViewEmployerPage(
        me.accountPermissions,
        page as EmployerPageName
      )
    ) {
      setNavigationCheck(true);
    } else {
      navigate(getScopedPageUrl("home"), { replace: true });
    }
  });

  const handleDownload = async (documentId: string, fileName: string) => {
    fetchFile("getEmployerDocumentPDF", documentId, fileName);
  };

  const accountsOptions = buildAutoCompleteOptions(
    authorisedAccounts,
    "name",
    "id"
  );
  accountsOptions.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <DocumentList
      page={page}
      getDocuments={getEmployerDocuments}
      onDownload={handleDownload}
      accountOptions={accountsOptions}
      isLoading={!navigationCheckComplete}
      isSuccess={navigationCheckComplete}
    />
  );
};

export default EmployerDocumentList;
